const createShrinkedStrNumberWithKMB = (
  str: string,
  maxCharactersAfterDot: number,
  numLevel: number,
  suffix: string
) => {
  const before = str.slice(0, -numLevel);
  const after = str.slice(-numLevel).slice(0, maxCharactersAfterDot - before.length);
  return `${before}${after ? "." : ""}${after}${suffix}`;
};

const shrinkStrNumberToKMB = (str: string, precision: number) => {
  if (str.length > 9) {
    return createShrinkedStrNumberWithKMB(str, precision, 9, "B");
  } else if (str.length > 6) {
    return createShrinkedStrNumberWithKMB(str, precision, 6, "M");
  } else if (str.length > 3) {
    return createShrinkedStrNumberWithKMB(str, precision, 3, "K");
  }
  return null;
};

export default function strNumPretifier({
  str,
  precision = 3,
}: {
  str: string;
  precision: number;
}) {
  try {
    const numParts = str.split(".");
    const beforeDot = numParts[0];
    const numberBiggerThan1000 = shrinkStrNumberToKMB(beforeDot, precision);
    if (numberBiggerThan1000) {
      return numberBiggerThan1000;
    }

    const afterDotPart = numParts[1] || "000";
    const afterDot = afterDotPart.slice(0, precision - beforeDot.length + 1);
    return `${beforeDot}.${afterDot}`;
  } catch (error) {
    console.error("Error in strNumPretifier", error);
    return str;
  }
}
